export default "__VITE_ASSET__813bea2d__"